export default "__VITE_ASSET__CjrcTXaJ__"